/**
 * Airline Rate Request page tour.
 *
 * data-tour attributes expected in AirlineRateRequestManager.jsx:
 *   rr-compose-panel    Left panel — compose / generate email drafts
 *   rr-drafts-panel     Right panel — saved drafts list
 */

export const rateRequestTour = {
  id: "rate-request",
  label: "Airline Rate Request",
  steps: [
    {
      target: null,
      title: "Requesting Rates from Airlines ✈️",
      description:
        "This page lets you send rate request emails to airlines for a shipment. You can generate a draft automatically, review it, and send it — all from here.",
      placement: "center",
    },
    {
      target: "rr-compose-panel",
      title: "Compose Your Rate Request",
      description:
        "Choose an airline, pick an email template, and let FreightKit generate a pre-filled rate request for you. You can edit the subject and body before sending.",
      hint: "Use the template dropdown to load a pre-written format — this saves time and keeps your emails consistent.",
      placement: "right",
    },
    {
      target: "rr-drafts-panel",
      title: "Your Saved Drafts",
      description:
        "Every draft you generate is saved here. You can select one or more drafts, review them, and send them all at once with a single click.",
      hint: "Drafts marked as sent will show a confirmation. Unsent drafts stay here until you're ready.",
      placement: "left",
    },
  ],
};
